<template>
    <div class="taskConfig">
        <!-- 互动主题 -->
        <div v-if="pageConfig.integralPlay.configState == 0">
            <h4 class="describe">会员主题</h4>
            <div class="uploadWrap">
                <h6 class="tips">背景</h6>
                <p class="careful">系统默认了背景图,可自由替换,尺寸为750*112px</p>
                <img :src="pageConfig.integralPlay.backgroundSrc" alt="" class="bgImages">
                <el-upload
                    style="text-align: center;"
                    action="/jd-point-web/image/upload"
                    :show-file-list="false"
                    :on-success="handleSuccess"
                    list-type="picture">
                    <button class="uploadBtn">重新上传</button>
                </el-upload>
            </div>
        </div>
        
        <!-- 积分兑换 -->
        <div v-if="pageConfig.integralPlay.configState == 99">
            <h4 class="describe">积分兑换</h4>
            <div class="integralWrap">
                <h6 class="tips">图标</h6>
                <div class="uploadBox">
                    <img :src="pageConfig.integralPlay.uploadIcon" class="icon">
                    <el-upload
                        style="text-align: center;"
                        action="/jd-point/image/upload"
                        :show-file-list="false"
                        :on-success="handleSuccess"
                        list-type="picture">
                        <button class="uploadBtn">重新上传</button>
                    </el-upload>
                </div>
            </div>
        </div>

        <!-- 活动列表 -->
        <playList v-if="pageConfig.integralPlay.configState == 5"></playList>
        <!-- 隐藏间隙 configState=0 为false  头部不显示间隙 -->
        <div class="hideGaps" v-show="pageConfig.integralPlay.configState">
            <!-- <el-checkbox v-model="pageHideGaps">隐藏该模块下方的背景色间隙</el-checkbox> -->
        </div>
    </div>
</template>

<script>
import { mapState, mapMutations } from "vuex"
import playList from './playList'

export default {
    components: {
        playList
    },
    computed: {
        ...mapState(["pageConfig"]),
        pageHideGaps: {
            get() {
                return this.$store.state.pageConfig.integralPlay.pageHideGaps
            },
            set(v) {
                this.hideGapsChange(v)
            }
        }
    },
    data() {
        return {
        }
    },
    methods: {
        ...mapMutations([
            "hideGapsChange",
            "replaceUploadIcon"
        ]),
        handleSuccess(res, file) {
            if(res && res.code == 1) {
                this.$message.success('上传图片成功')
                this.replaceUploadIcon(res.data)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.taskConfig {
    height: 100%;
    .uploadWrap {
        box-sizing: border-box;
        padding: 20px 24px;
        text-align: left;
        border: 1px solid #F3F3F3;
        .bgImages {
            width: 100%;
            height: 113px;
        }
        .uploadBtn {
            display: block;
            margin: 20px auto 0;
            width: 98px;
            height: 32px;
            line-height: 30px;
            background: #FFFFFF;
            border: 1px solid #CCCCCC;
            border-radius: 3px;
            color: #999;
            font-size: 14px;
            font-weight: 400;
        }
    }
    .integralWrap {
        box-sizing: border-box;
        padding: 20px 24px;
        text-align: left;
        border: 1px solid #F3F3F3;
        .uploadBox {
            display: flex;
            align-items: center;
            margin-top: 20px;
            .icon {
                padding: 9px;
                width: 38px;
                background-color: #EEEEEE;
            }
            .uploadBtn {
                width: 98px;
                height: 32px;
                background: #FFFFFF;
                border: 1px solid #CCCCCC;
                border-radius: 3px;
                margin-left: 12px;
                color: #999;
                font-size: 14px;
                font-weight: 400;
            }
        }
    }
    .describe {
        display: flex;
        flex-direction: column;
        justify-content: center;
        box-sizing: border-box;
        padding-left: 28px;
        margin: 0;
        text-align: left;
        height: 64px;
        background-color: #f5f5f5;
        color: #333;
        font-size: 16px;
        font-weight: 500;
        .desc {
            margin-top: 5px;
            color: #999;
            font-size: 14px;
            font-weight: 400;
        }
    }
    .tips {
        position: relative;
        display: inline-block;
        color: #333;
        font-size: 14px;
        font-weight: 500;
        &::after {
            content: '*';
            position: absolute;
            right: -8px;
            top: 2px;
            color: #FF3A27;
        }
    }
    .careful {
        margin: 8px 0 20px 0;
        color: #333;
        font-size: 14px;
        font-weight: 400;
    }
}
</style>
